var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"mandatory"},[_c('span',[_vm._v("*")]),_vm._v(" = "+_vm._s(_vm.wording.editor.mandatoryFields))])
}
var staticRenderFns = []

export { render, staticRenderFns }